import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, mergeProps as _mergeProps, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_AccountableAccountFilter = _resolveComponent("AccountableAccountFilter")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_CompaniesTable = _resolveComponent("CompaniesTable")!
  const _component_select_user = _resolveComponent("select-user")!
  const _component_select_bankAccount = _resolveComponent("select-bankAccount")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_AccountableAccountEdition = _resolveComponent("AccountableAccountEdition")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.haveSlot)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.btnMode)
            ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                key: 0,
                "hide-details": true,
                readonly: "",
                label: !_ctx.accountableAccountString ? _ctx.accountableAccountTitle : undefined,
                outlined: _ctx.outlined,
                rounded: _ctx.rounded,
                style: {"overflow-x":"hidden"},
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (!_ctx.disabled ? (_ctx.dialog = true) : ''), ["stop"])),
                "data-cy": _ctx.cypressPrefixKey + 'accountableAccount',
                onKeypress: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.dialog = false), ["tab"])),
                "model-value": _ctx.accountableAccountString,
                density: "compact"
              }, null, 8, ["label", "outlined", "rounded", "data-cy", "model-value"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.dialog) = $event)),
      title: _ctx.dialogTitle,
      validDisabled: !_ctx.needValidation && !_ctx.displayValidBtn ? false : _ctx.validDisabled,
      hideValid: !_ctx.needValidation && !_ctx.displayValidBtn,
      "previous-display": _ctx.step !== 'default',
      validTitle: _ctx.validText,
      onValid: _ctx.onValidation,
      onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onClose())),
      onPrevious: _cache[20] || (_cache[20] = ($event: any) => (_ctx.previous())),
      "min-width": "50vw"
    }, _createSlots({
      default: _withCtx(() => [
        _createVNode(_component_v_window, {
          modelValue: _ctx.step,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.step) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window_item, { value: 'default' }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: _ctx.editAccountableAccount ? 11 : 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_AccountableAccountFilter, {
                          search: _ctx.search,
                          "onUpdate:search": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
                          thirdParty: _ctx.tiersSearch,
                          "onUpdate:thirdParty": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tiersSearch) = $event)),
                          vatType: _ctx.vatTypeSearch,
                          "onUpdate:vatType": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.vatTypeSearch) = $event)),
                          vatOperation: _ctx.vatOperationSearch,
                          "onUpdate:vatOperation": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.vatOperationSearch) = $event)),
                          transactionType: _ctx.transactionTypeSearch,
                          "onUpdate:transactionType": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.transactionTypeSearch) = $event)),
                          lettering: _ctx.showLettering,
                          "onUpdate:lettering": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showLettering) = $event)),
                          publish: _ctx.showPublished,
                          "onUpdate:publish": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showPublished) = $event)),
                          default: _ctx.showDefault,
                          "onUpdate:default": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showDefault) = $event)),
                          activeFilters: _ctx.activeFilters,
                          "onUpdate:activeFilters": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.activeFilters) = $event)),
                          onKeypressEnter: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectAccountableAccount())),
                          "data-cy": _ctx.cypressPrefixKey + 'accountableAccount-search'
                        }, null, 8, ["search", "thirdParty", "vatType", "vatOperation", "transactionType", "lettering", "publish", "default", "activeFilters", "data-cy"])
                      ]),
                      _: 1
                    }, 8, ["cols"]),
                    (_ctx.editAccountableAccount)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "1",
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              icon: "$add",
                              variant: "flat",
                              onClick: _ctx.newAccountableAccount,
                              size: "small"
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_ctx.activateFreeTag && _ctx.selectedCompany)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      "no-gutters": "",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_FreeTag, {
                              companyTags: _ctx.allCompanyTags,
                              company: _ctx.selectedCompany,
                              createIfMissing: true,
                              onOnTagsChanged: _ctx.onTagsChanged
                            }, null, 8, ["companyTags", "company", "onOnTagsChanged"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.suggestions && _ctx.suggestions.length)
                  ? (_openBlock(), _createBlock(_component_v_list, {
                      key: 1,
                      lines: "three",
                      subheader: "",
                      density: "compact",
                      width: "100%"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_subheader, null, {
                          default: _withCtx(() => _cache[22] || (_cache[22] = [
                            _createTextVNode("Suggestions")
                          ])),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (suggestion) => {
                          return _withDirectives((_openBlock(), _createBlock(_component_v_list_item, {
                            key: suggestion.key,
                            ripple: "",
                            border: "",
                            rounded: "lg",
                            onClick: ($event: any) => (_ctx.toggleSuggestion(suggestion)),
                            class: _normalizeClass(
                                    !_ctx.$vuetify.display.mobile
                                        ? 'mb-2 oss-list-item'
                                        : 'mb-2 px-2 oss-list-item'
                                )
                          }, {
                            append: _withCtx(() => [
                              (_ctx.selected.name != suggestion.accountableAccount.name)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    color: "grey",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                                      _createTextVNode(" $oss-circle-uncheck ")
                                    ])),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 1,
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                                      _createTextVNode("$oss-circle-check")
                                    ])),
                                    _: 1
                                  }))
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getSuggestionName(suggestion)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_list_item_subtitle, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(suggestion.accountableAccount.description), 1),
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_v_chip, {
                                      color: "green",
                                      size: "x-small",
                                      variant: "flat"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          size: "x-small",
                                          location: "start"
                                        }, {
                                          default: _withCtx(() => _cache[23] || (_cache[23] = [
                                            _createTextVNode(" $star ")
                                          ])),
                                          _: 1
                                        }),
                                        _createTextVNode(" " + _toDisplayString(Math.round(suggestion.percentage * 100) +
                                                "% , " +
                                                suggestion.count +
                                                " fois"), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (suggestion.clientCount)
                                      ? (_openBlock(), _createBlock(_component_v_chip, {
                                          key: 0,
                                          color: "secondary",
                                          class: "ml-2",
                                          size: "x-small",
                                          variant: "flat"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              size: "x-small",
                                              location: "start"
                                            }, {
                                              default: _withCtx(() => _cache[24] || (_cache[24] = [
                                                _createTextVNode("$star")
                                              ])),
                                              _: 1
                                            }),
                                            _createTextVNode(_toDisplayString("Utilisé pour ce client " +
                                                suggestion.clientCount +
                                                " fois"), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "class"])), [
                            [_vShow, _ctx.isShow(suggestion.accountableAccount)]
                          ])
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.suggestions && _ctx.suggestions.length)
                  ? (_openBlock(), _createBlock(_component_v_divider, { key: 2 }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_list_subheader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.accountableAccountTitle), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_virtual_scroll, {
                  items: _ctx.filteredAccountableAccounts,
                  "item-height": 66,
                  height: "504",
                  width: "100%"
                }, {
                  default: _withCtx(({ item }) => [
                    _createVNode(_component_v_hover, null, {
                      default: _withCtx(({ isHovering, props }) => [
                        (_openBlock(), _createBlock(_component_v_list_item, _mergeProps(props, {
                          key: 'a_' + item.name,
                          ripple: "",
                          onClick: ($event: any) => (
                                            _ctx.displayCheckIcon ? _ctx.toggleAccountableAccount(item) : null
                                        ),
                          class: 
                                            !_ctx.$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item'
                                                : 'mb-2 px-2 oss-list-item'
                                        ,
                          "data-cy": 'accountableAccount-' + item.name,
                          border: "",
                          rounded: "xl",
                          lines: "two",
                          onKeypress: _withKeys(($event: any) => (
                                            _ctx.displayCheckIcon ? _ctx.toggleAccountableAccount(item) : null
                                        ), ["enter"])
                        }), _createSlots({
                          append: _withCtx(() => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                (
                                                        !item.invoiceProduct &&
                                                        _ctx.editAccountableAccount &&
                                                        isHovering
                                                    )
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "6",
                                      class: "d-flex align-center justify-center px-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: "$oss-edit",
                                          onClick: _withModifiers(($event: any) => (
                                                            _ctx.setEditAccountableAccount(item)
                                                        ), ["stop"]),
                                          size: "small"
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                (_ctx.displayCheckIcon)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 1,
                                      cols: "6",
                                      class: "d-flex align-center justify-center px-1"
                                    }, {
                                      default: _withCtx(() => [
                                        (!item.isSelected(_ctx.selected))
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 0,
                                              color: "grey",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[28] || (_cache[28] = [
                                                _createTextVNode(" $oss-circle-uncheck ")
                                              ])),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 1,
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[29] || (_cache[29] = [
                                                _createTextVNode(" $oss-circle-check ")
                                              ])),
                                              _: 1
                                            }))
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.getDisplayName(item)) + " ", 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.complementInfo(item), (info) => {
                                  return (_openBlock(), _createBlock(_component_v_chip, {
                                    key: item.name + '-' + info,
                                    label: "",
                                    class: "ml-2",
                                    size: "x-small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024),
                            (_ctx.isAccountingUser || item.invoiceProduct)
                              ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                                  default: _withCtx(() => [
                                    (_ctx.isAccountingUser)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.description), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, [
                          (!item.isStandard || item.invoiceProduct)
                            ? {
                                name: "prepend",
                                fn: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                                      _createTextVNode("$subdirectory_arrow_right")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                key: "0"
                              }
                            : undefined
                        ]), 1040, ["onClick", "class", "data-cy", "onKeypress"]))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["items"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 'company' }, {
              default: _withCtx(() => [
                (_ctx.step === 'company')
                  ? (_openBlock(), _createBlock(_component_CompaniesTable, {
                      key: 0,
                      modelValue: _ctx.thirdPartyCompany,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.thirdPartyCompany) = $event)),
                      "show-generic-company": _ctx.selectedAccountableAccount.name.startsWith('401'),
                      "show-customer-companies": 
                            (!_ctx.showExistingCompanies &&
                                _ctx.selectedAccountableAccount.name.startsWith('411')) ||
                            _ctx.selectedAccountableAccount.name.startsWith('491')
                        ,
                      "show-supplier-companies": 
                            !_ctx.showExistingCompanies &&
                            _ctx.selectedAccountableAccount.name.startsWith('401')
                        ,
                      "show-existing-companies": _ctx.showExistingCompanies,
                      "parent-company-id": _ctx.companyId,
                      "wizard-mode": true
                    }, null, 8, ["modelValue", "show-generic-company", "show-customer-companies", "show-supplier-companies", "show-existing-companies", "parent-company-id"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 'user' }, {
              default: _withCtx(() => [
                (_ctx.step === 'user')
                  ? (_openBlock(), _createBlock(_component_select_user, {
                      key: 0,
                      ref: "selectUser",
                      class: "px-1",
                      modelValue: _ctx.thirdPartyUser,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.thirdPartyUser) = $event)),
                      companyId: _ctx.companyId,
                      step: _ctx.userStep,
                      "onUpdate:step": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.userStep) = $event)),
                      onIsValidUser: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isValidUser = $event))
                    }, null, 8, ["modelValue", "companyId", "step"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: 'bankAccount' }, {
              default: _withCtx(() => [
                (_ctx.step === 'bankAccount')
                  ? (_openBlock(), _createBlock(_component_select_bankAccount, {
                      key: 0,
                      "company-id": _ctx.companyId,
                      modelValue: _ctx.thirdPartyBank,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.thirdPartyBank) = $event))
                    }, null, 8, ["company-id", "modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 2
    }, [
      (_ctx.step !== 'user')
        ? {
            name: "activator",
            fn: _withCtx(({ props }) => [
              _renderSlot(_ctx.$slots, "activator", {
                props: props,
                accountableAccountName: _ctx.accountableAccountString
              })
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "title", "validDisabled", "hideValid", "previous-display", "validTitle", "onValid"]),
    (_ctx.editAccountDialog)
      ? (_openBlock(), _createBlock(_component_AccountableAccountEdition, {
          key: 1,
          modelValue: _ctx.editAccountDialog,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.editAccountDialog) = $event)),
          aaCharacterCount: _ctx.accountableAccountTable.aaCharacterCount,
          accountableAccount: _ctx.accountableAccountEdition,
          existingAccountableAccounts: _ctx.accountableAccountTable.accountableAccounts,
          onValidate: _ctx.upsertAccountableAccount
        }, null, 8, ["modelValue", "aaCharacterCount", "accountableAccount", "existingAccountableAccounts", "onValidate"]))
      : _createCommentVNode("", true)
  ]))
}